













































import { Component, Vue, PropSync } from 'vue-property-decorator';
import ModalIdentityVerificationWasCompletedViewModel
  from '@/vue-app/view-models/components/on-boarding/alerts/modal-identity-verification-was-completed-view-model';

@Component({ name: 'ModalIdentityVerificationWasCompleted' })
export default class ModalIdentityVerificationWasCompleted extends Vue {
  @PropSync('isOpen', { type: Boolean })
  synced_is_open!: boolean;

  identity_verification_was_completed_view_model = Vue.observable(
    new ModalIdentityVerificationWasCompletedViewModel(),
  );
}
